import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/** Stable id/slug for filters when category is a string or { id, name } */
export function categoryId(category) {
  if (category == null || category === "") return "";
  if (typeof category === "string") return category;
  if (typeof category === "object" && category !== null) {
    return String(category.id ?? category.name ?? "");
  }
  return String(category);
}

/** Safe text for JSX when category may be string or { id, name } */
export function categoryLabel(category) {
  if (category == null || category === "") return "";
  if (typeof category === "string") return category;
  if (typeof category === "object" && category !== null) {
    return String(category.name ?? category.id ?? "");
  }
  return String(category);
}

/** Use whenever API data may be missing or not an array. */
export function safeArray(value) {
  return Array.isArray(value) ? value : [];
}

export function safeStr(value, fallback = "") {
  if (value == null) return fallback;
  return String(value);
}

export function safeNum(value, fallback = 0) {
  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
}

/**
 * GET /courses returns { courses, total, page, pages } in production;
 * some callers may still expect a raw array.
 */
export function coursesFromApiResponse(data) {
  if (data == null) return [];
  if (Array.isArray(data)) return data;
  if (Array.isArray(data.courses)) return data.courses;
  return [];
}
